import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.svg";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import { Link as ScrollLink, scroller } from 'react-scroll';



export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = [ "Data Science Graduate", "Motivated AI Engineer", "Data Analytics Enthusiast"];
  const period = 1000;
  const scrollToSection = (sectionId) => {
    scroller.scrollTo(sectionId, {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart'
    });
  };
  

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  }, [text])

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex(prevIndex => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex(prevIndex => prevIndex + 1);
    }
  }

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <span className="tagline">Welcome to my Portfolio</span>
                <h1>{`Hi! I am Nour `} <span className="txt-rotate" dataPeriod="800" data-rotate='[ "Data Science Student", "Motivated AI Student", "Data Analytics Enthusiast" ]'><span className="wrap">{text}</span></span></h1>
                <p>Dedicated Junior Data Scientist with a passion for leveraging data to drive insights and solutions. <br></br> <br></br>Currently looking for a kickstart opportunity in AI and data analysis domains. <br></br><br></br>Seeking to merge theoretical knowledge with practical experience and eager to connect with fellow enthusiasts, mentors, and professionals in the AI realm to explore new opportunities and exchange insights. <br></br><br></br>Let's connect and delve into the fascinating world of data together! </p>
                {/* <ScrollLink to="connect" spy={true} smooth={true} duration={500} className="vvd"> */}
                <button onClick={() => window.open('https://www.linkedin.com/in/nour-ben-aouicha-33031422b/', '_blank')}>Let’s Connect on LinkedIn <ArrowRightCircle size={25} /></button>

              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img"/>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
